function OffenderAlcoholSchedBlock() {
    "use script";
    this.__type = 'OffenderAlcoholSchedBlock:www.veritracks.com';
    this.Id = -1;
    this.AppUserId = null;
    this.EnrolleeId = null;
    this.EnrolleeTimeZone = null;
    this.ScheduleType = null;
    this.OrganizationId = null;
    this.StartDate = null;
    this.StopDate = null;
    this.DayOfWeek = '';
    this.StartHour = '';
    this.StopHour = '';
    this.Name = '';
    this.NumberOfTest = null;
    this.MinuteBetweenTest = null;
    this.ConfirmFlag = 0;
    this.IsActive = 1;
    this.StartDateUTCString = '';
    this.StopDateUTCString = '';
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAlcoholSchedBlock;
}